import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Video } from '../../models/video.model';

export const loadVideo = createAction(
  '[Video] Load to store',
  props<{ videos: Video[] }>(),
);

export const getVideos = createAction(
  '[Video] Get videos',
  props<{ uid: string }>(),
);

export const getVideo = createAction(
  '[Video] Get video',
  props<{ id: string }>(),
);

export const getVideosFailure = createAction(
  '[Video] Get Videos Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Video Actions
export const create = createAction(
  '[Video] Create video',
  props<{ video: Partial<Video> }>(),
);
export const createFailure = createAction(
  '[Video] Create video failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[Video] Create video success',
  props<{ video: Video }>(),
);

// Update Video Actions
export const update = createAction(
  '[Video] Update',
  props<{ video: Partial<Video> }>(),
);
export const updateFailure = createAction(
  '[Video] Update failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[Video] Update success',
  props<{ video: Video }>(),
);

// Delete Video Actions
export const deleteAction = createAction(
  '[Video] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[Video] Delete failure',
  props<{ error: any }>(),
);
export const deleteSuccess = createAction(
  '[Video] Delete success',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[Video] Clear from store',
  props<{ id: string }>(),
);

export const select = createAction('[Video] Select', props<{ id: string }>());
export const unselect = createAction(
  '[Video] Unselect',
  props<{ id: string }>(),
);

export const clear = createAction('[Video] Clear Videos');
